import { AnswerMultiQuestionMeta, AnswerMultiQuestionPayload } from 'types/store/AnswerMultiQuestion';
import { createAsyncReducer } from 'utils/Redux';

import { answerMultiQuestionActions } from '../actions';

export default createAsyncReducer<AnswerMultiQuestionMeta, AnswerMultiQuestionPayload>(answerMultiQuestionActions);
